<template>
    <OnboardingCustom v-if="is_onboarding_visible"  :steps="steps"></OnboardingCustom>

  <div class="general-wrapp mx-auto">
    <div v-if="caseData != null">
      <CaseNavigation
        :activeTab="1"
        :caseData="caseData"
        id="case-nav-wrapper"
      ></CaseNavigation>

      <section class="py-3">
        <div class="container px-4 mx-auto">
          <div class="flex flex-wrap items-center -mx-4 -mb-6">
            <div class="w-full md:w-3/12 mb-6">
              <div
                class="max-w-xs md:max-w-none mx-auto p-6 bg-custom-container rounded-xl"
              >
                <div class="flex flex-wrap items-center -m-2">
                  <div class="w-auto p-2">
                    <div
                      class="flex flex-shrink-0 w-12 h-12 items-center justify-center bg-blue-500 bg-opacity-20 text-blue-500 rounded-xl"
                    >
                      <svg
                        width="22"
                        height="22"
                        viewbox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21 16H1C0.734784 16 0.48043 16.1054 0.292893 16.2929C0.105357 16.4804 0 16.7348 0 17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16ZM21 20H1C0.734784 20 0.48043 20.1054 0.292893 20.2929C0.105357 20.4804 0 20.7348 0 21C0 21.2652 0.105357 21.5196 0.292893 21.7071C0.48043 21.8946 0.734784 22 1 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21C22 20.7348 21.8946 20.4804 21.7071 20.2929C21.5196 20.1054 21.2652 20 21 20ZM5 6C4.80222 6 4.60888 6.05865 4.44443 6.16853C4.27998 6.27841 4.15181 6.43459 4.07612 6.61732C4.00043 6.80004 3.98063 7.00111 4.01921 7.19509C4.0578 7.38907 4.15304 7.56725 4.29289 7.70711C4.43275 7.84696 4.61093 7.9422 4.80491 7.98079C4.99889 8.01937 5.19996 7.99957 5.38268 7.92388C5.56541 7.84819 5.72159 7.72002 5.83147 7.55557C5.94135 7.39112 6 7.19778 6 7C6 6.73478 5.89464 6.48043 5.70711 6.29289C5.51957 6.10536 5.26522 6 5 6ZM19 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V11C0 11.7956 0.31607 12.5587 0.87868 13.1213C1.44129 13.6839 2.20435 14 3 14H19C19.7956 14 20.5587 13.6839 21.1213 13.1213C21.6839 12.5587 22 11.7956 22 11V3C22 2.20435 21.6839 1.44129 21.1213 0.87868C20.5587 0.31607 19.7956 0 19 0ZM20 11C20 11.2652 19.8946 11.5196 19.7071 11.7071C19.5196 11.8946 19.2652 12 19 12H3C2.73478 12 2.48043 11.8946 2.29289 11.7071C2.10536 11.5196 2 11.2652 2 11V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V11ZM11 4C10.4067 4 9.82664 4.17595 9.33329 4.50559C8.83994 4.83524 8.45542 5.30377 8.22836 5.85195C8.0013 6.40013 7.94189 7.00333 8.05764 7.58527C8.1734 8.16721 8.45912 8.70176 8.87868 9.12132C9.29824 9.54088 9.83279 9.8266 10.4147 9.94236C10.9967 10.0581 11.5999 9.9987 12.1481 9.77164C12.6962 9.54458 13.1648 9.16006 13.4944 8.66671C13.8241 8.17336 14 7.59334 14 7C14 6.20435 13.6839 5.44129 13.1213 4.87868C12.5587 4.31607 11.7956 4 11 4ZM11 8C10.8022 8 10.6089 7.94135 10.4444 7.83147C10.28 7.72159 10.1518 7.56541 10.0761 7.38268C10.0004 7.19996 9.98063 6.99889 10.0192 6.80491C10.0578 6.61093 10.153 6.43275 10.2929 6.29289C10.4327 6.15304 10.6109 6.0578 10.8049 6.01921C10.9989 5.98063 11.2 6.00043 11.3827 6.07612C11.5654 6.15181 11.7216 6.27998 11.8315 6.44443C11.9414 6.60888 12 6.80222 12 7C12 7.26522 11.8946 7.51957 11.7071 7.70711C11.5196 7.89464 11.2652 8 11 8ZM17 6C16.8022 6 16.6089 6.05865 16.4444 6.16853C16.28 6.27841 16.1518 6.43459 16.0761 6.61732C16.0004 6.80004 15.9806 7.00111 16.0192 7.19509C16.0578 7.38907 16.153 7.56725 16.2929 7.70711C16.4327 7.84696 16.6109 7.9422 16.8049 7.98079C16.9989 8.01937 17.2 7.99957 17.3827 7.92388C17.5654 7.84819 17.7216 7.72002 17.8315 7.55557C17.9414 7.39112 18 7.19778 18 7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6Z"
                          fill="#194BFB"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div class="w-auto p-2">
                    <h5 class="text-xs text-gray-300 leading-5 font-semibold">
                      VPS
                    </h5>
                    <div class="flex flex-wrap items-center -m-1">
                      <div class="w-auto p-1">
                        <span
                          class="text-xl leading-none text-gray-100 font-semibold"
                          >{{ caseData.vps }}</span
                        >
                      </div>
                      <div class="w-auto p-1"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full md:md:w-4/12 px-4 mb-6">
              <div
                class="max-w-xs md:max-w-none mx-auto p-6 bg-custom-container rounded-xl"
              >
                <div class="flex flex-wrap items-center -m-2">
                  <div class="w-auto p-2">
                    <div
                      class="flex flex-shrink-0 w-12 h-12 items-center justify-center bg-blue-500 bg-opacity-20 text-blue-500 rounded-xl"
                    >
                      <svg
                        width="22"
                        height="18"
                        viewbox="0 0 22 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.3 9.22C11.8336 8.75813 12.2616 8.18688 12.5549 7.54502C12.8482 6.90316 13 6.20571 13 5.5C13 4.17392 12.4732 2.90215 11.5355 1.96447C10.5979 1.02678 9.32608 0.5 8 0.5C6.67392 0.5 5.40215 1.02678 4.46447 1.96447C3.52678 2.90215 3 4.17392 3 5.5C2.99999 6.20571 3.1518 6.90316 3.44513 7.54502C3.73845 8.18688 4.16642 8.75813 4.7 9.22C3.30014 9.85388 2.11247 10.8775 1.27898 12.1685C0.445495 13.4596 0.00147185 14.9633 0 16.5C0 16.7652 0.105357 17.0196 0.292893 17.2071C0.48043 17.3946 0.734784 17.5 1 17.5C1.26522 17.5 1.51957 17.3946 1.70711 17.2071C1.89464 17.0196 2 16.7652 2 16.5C2 14.9087 2.63214 13.3826 3.75736 12.2574C4.88258 11.1321 6.4087 10.5 8 10.5C9.5913 10.5 11.1174 11.1321 12.2426 12.2574C13.3679 13.3826 14 14.9087 14 16.5C14 16.7652 14.1054 17.0196 14.2929 17.2071C14.4804 17.3946 14.7348 17.5 15 17.5C15.2652 17.5 15.5196 17.3946 15.7071 17.2071C15.8946 17.0196 16 16.7652 16 16.5C15.9985 14.9633 15.5545 13.4596 14.721 12.1685C13.8875 10.8775 12.6999 9.85388 11.3 9.22ZM8 8.5C7.40666 8.5 6.82664 8.32405 6.33329 7.99441C5.83994 7.66476 5.45542 7.19623 5.22836 6.64805C5.0013 6.09987 4.94189 5.49667 5.05764 4.91473C5.1734 4.33279 5.45912 3.79824 5.87868 3.37868C6.29824 2.95912 6.83279 2.6734 7.41473 2.55764C7.99667 2.44189 8.59987 2.5013 9.14805 2.72836C9.69623 2.95542 10.1648 3.33994 10.4944 3.83329C10.8241 4.32664 11 4.90666 11 5.5C11 6.29565 10.6839 7.05871 10.1213 7.62132C9.55871 8.18393 8.79565 8.5 8 8.5ZM17.74 8.82C18.38 8.09933 18.798 7.20905 18.9438 6.25634C19.0896 5.30362 18.9569 4.32907 18.5618 3.45C18.1666 2.57093 17.5258 1.8248 16.7165 1.30142C15.9071 0.77805 14.9638 0.499742 14 0.5C13.7348 0.5 13.4804 0.605357 13.2929 0.792893C13.1054 0.98043 13 1.23478 13 1.5C13 1.76522 13.1054 2.01957 13.2929 2.20711C13.4804 2.39464 13.7348 2.5 14 2.5C14.7956 2.5 15.5587 2.81607 16.1213 3.37868C16.6839 3.94129 17 4.70435 17 5.5C16.9986 6.02524 16.8593 6.5409 16.5961 6.99542C16.3328 7.44994 15.9549 7.82738 15.5 8.09C15.3517 8.17552 15.2279 8.29766 15.1404 8.44474C15.0528 8.59182 15.0045 8.7589 15 8.93C14.9958 9.09976 15.0349 9.2678 15.1137 9.41826C15.1924 9.56872 15.3081 9.69665 15.45 9.79L15.84 10.05L15.97 10.12C17.1754 10.6917 18.1923 11.596 18.901 12.7263C19.6096 13.8566 19.9805 15.1659 19.97 16.5C19.97 16.7652 20.0754 17.0196 20.2629 17.2071C20.4504 17.3946 20.7048 17.5 20.97 17.5C21.2352 17.5 21.4896 17.3946 21.6771 17.2071C21.8646 17.0196 21.97 16.7652 21.97 16.5C21.9782 14.9654 21.5938 13.4543 20.8535 12.1101C20.1131 10.7659 19.0413 9.63331 17.74 8.82Z"
                          fill="#194BFB"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div class="w-auto p-2">
                    <h5 class="text-xs text-gray-300 leading-5 font-semibold">
                      Vrsta Postupka
                    </h5>
                    <div class="flex flex-wrap items-center -m-1">
                      <div class="w-auto p-1">
                        <span
                          class="text-l leading-none text-gray-100 font-semibold"
                          >{{ caseData.case_type }}</span
                        >
                      </div>
                      <div class="w-auto p-1"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full md:md:w-5/12 mb-6">
             <div
                class="max-w-xs md:max-w-none mx-auto p-6 bg-custom-container rounded-xl"
              >
                 <div class="flex flex-wrap items-center -m-2">
                  <div class="w-auto p-2">
                    <div
                      class="flex flex-shrink-0 w-12 h-12 items-center justify-center bg-blue-500 bg-opacity-20 text-blue-500 rounded-xl"
                    >
                      <svg
                        width="20"
                        height="16"
                        viewbox="0 0 20 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 5.50001H16.68L15.43 2.38001C15.2068 1.82527 14.8228 1.3499 14.3275 1.01492C13.8321 0.679935 13.248 0.500629 12.65 0.500012H6.65C5.95529 0.498024 5.28142 0.737203 4.74342 1.17673C4.20541 1.61625 3.83662 2.22886 3.7 2.91001L3.18 5.50001H3C2.20435 5.50001 1.44129 5.81608 0.87868 6.37869C0.316071 6.9413 0 7.70436 0 8.50001V11.5C0 11.7652 0.105357 12.0196 0.292893 12.2071C0.48043 12.3947 0.734784 12.5 1 12.5H2C2 13.2957 2.31607 14.0587 2.87868 14.6213C3.44129 15.1839 4.20435 15.5 5 15.5C5.79565 15.5 6.55871 15.1839 7.12132 14.6213C7.68393 14.0587 8 13.2957 8 12.5H12C12 13.2957 12.3161 14.0587 12.8787 14.6213C13.4413 15.1839 14.2044 15.5 15 15.5C15.7956 15.5 16.5587 15.1839 17.1213 14.6213C17.6839 14.0587 18 13.2957 18 12.5H19C19.2652 12.5 19.5196 12.3947 19.7071 12.2071C19.8946 12.0196 20 11.7652 20 11.5V8.50001C20 7.70436 19.6839 6.9413 19.1213 6.37869C18.5587 5.81608 17.7956 5.50001 17 5.50001ZM11 2.50001H12.65C12.8486 2.50181 13.0421 2.56269 13.206 2.67488C13.3698 2.78708 13.4965 2.94552 13.57 3.13001L14.52 5.50001H11V2.50001ZM5.66 3.30001C5.70675 3.07074 5.83242 2.86511 6.01514 2.71894C6.19786 2.57277 6.42605 2.49529 6.66 2.50001H9V5.50001H5.22L5.66 3.30001ZM5 13.5C4.80222 13.5 4.60888 13.4414 4.44443 13.3315C4.27998 13.2216 4.15181 13.0654 4.07612 12.8827C4.00043 12.7 3.98063 12.4989 4.01921 12.3049C4.0578 12.1109 4.15304 11.9328 4.29289 11.7929C4.43275 11.6531 4.61093 11.5578 4.80491 11.5192C4.99889 11.4806 5.19996 11.5004 5.38268 11.5761C5.56541 11.6518 5.72159 11.78 5.83147 11.9444C5.94135 12.1089 6 12.3022 6 12.5C6 12.7652 5.89464 13.0196 5.70711 13.2071C5.51957 13.3947 5.26522 13.5 5 13.5ZM15 13.5C14.8022 13.5 14.6089 13.4414 14.4444 13.3315C14.28 13.2216 14.1518 13.0654 14.0761 12.8827C14.0004 12.7 13.9806 12.4989 14.0192 12.3049C14.0578 12.1109 14.153 11.9328 14.2929 11.7929C14.4327 11.6531 14.6109 11.5578 14.8049 11.5192C14.9989 11.4806 15.2 11.5004 15.3827 11.5761C15.5654 11.6518 15.7216 11.78 15.8315 11.9444C15.9414 12.1089 16 12.3022 16 12.5C16 12.7652 15.8946 13.0196 15.7071 13.2071C15.5196 13.3947 15.2652 13.5 15 13.5ZM18 10.5H17.22C16.9388 10.1907 16.5961 9.94348 16.2138 9.77434C15.8315 9.6052 15.418 9.51783 15 9.51783C14.582 9.51783 14.1685 9.6052 13.7862 9.77434C13.4039 9.94348 13.0612 10.1907 12.78 10.5H7.22C6.93882 10.1907 6.59609 9.94348 6.21378 9.77434C5.83148 9.6052 5.41805 9.51783 5 9.51783C4.58195 9.51783 4.16852 9.6052 3.78622 9.77434C3.40391 9.94348 3.06118 10.1907 2.78 10.5H2V8.50001C2 8.2348 2.10536 7.98044 2.29289 7.79291C2.48043 7.60537 2.73478 7.50001 3 7.50001H17C17.2652 7.50001 17.5196 7.60537 17.7071 7.79291C17.8946 7.98044 18 8.2348 18 8.50001V10.5Z"
                          fill="#194BFB"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div class="w-auto p-2">
                    <h5 class="text-xs text-gray-300 leading-5 font-semibold">
                      Nadležno tijelo
                    </h5>
                    <div class="flex flex-wrap items-center -m-1" v-for="(leg_body,key) in caseData.case_lb" :key="key" v-if="caseData.case_lb.length > 0">
                      <div class="w-auto p-1">
                        <span
                          class="text-l leading-none text-gray-100 font-semibold"
                          >{{ leg_body.institucija.naziv }}</span
                        >
                      </div>
                      <div class="w-auto p-1"></div>
                    </div>
                    <div v-else class="flex flex-wrap items-center -m-1">
                      <div class="w-auto p-1">
                        <span
                          class="text-l leading-none text-gray-100 font-semibold"
                          >N/A</span
                        >
                      </div>
                      <div class="w-auto p-1"></div>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-8">
        <div class="container mx-auto">
          <div class="flex ">
            <div class="w-full flex gap-4">
              <div class="p-8 bg-custom-container rounded-xl w-7/12">
                <div class="pb-8 mb-8 border-b border-gray-400">
                  <div
                    class="flex flex-wrap items-center justify-between -mb-4"
                  >
                    <h3
                      class="text-lg font-semibold text-gray-100 mb-4"
                      contenteditable="false"
                    >
                      Članovi tima
                    </h3>
                  </div>
                  <div class="flex flex-wrap">
                    <div
                      v-for="(single_clan, key) in caseData.lawyers"
                      :key="key"
                      :class="[
                        'flex py-3 pl-4 my-4 pr-6 mr-2 items-center justify-between rounded-full w-5/12',
                        single_clan.part.id_status == 2
                          ? 'bg-purple-700'
                          : 'bg-gray-600 ',
                      ]"
                    >
                      <div class="flex items-center">
                        <img
                          class="h-8 w-8 mr-3 rounded-full"
                          :src="single_clan.avatar"
                          alt=""
                        />
                        <div>
                          <h5
                            class="text-sm leading-none font-semibold text-gray-100"
                          >
                            {{ single_clan.odvjetnik.ime }}
                            {{ single_clan.odvjetnik.prezime }}
                          </h5>
                          <span class="text-xs font-medium text-gray-300">{{
                            single_clan.part.naziv
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-8 bg-custom-container rounded-xl w-5/12">
                <div class="pb-8 mb-8 border-b border-gray-400">
                  <div
                    class="flex flex-wrap items-center justify-between -mb-4"
                  >
                    <h3
                      class="text-lg font-semibold text-gray-100 mb-4"
                      contenteditable="false"
                    >
                      Sudionici
                    </h3>
                  </div>
                  <div class="flex flex-wrap">
                    <div
                      v-for="(single_clan, key) in caseData.case_all_connected_people"
                      :key="key"
                      :class="[
                        'flex py-3 pl-4 my-4 pr-6 mr-2 items-center justify-between rounded-full w-auto bg-gray-600 ',
                      ]"
                    >
                      <div class="flex items-center">
                        <!-- <img
                          class="h-8 w-8 mr-3 rounded-full"
                          :src="single_clan.avatar"
                          alt=""
                        /> -->
                        <div>
                          <h5
                            class=" leading-none font-semibold text-gray-100"
                          >
                            {{ single_clan.name }}
                          </h5>
                          <span class="text-xs font-medium text-gray-300">{{
                            single_clan.status_name
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import gsap from "gsap";
import router from "@/router";
import moment from "moment";
import { useUserStore } from "@/store/auth.session";

import CaseNavigation from "@/components/Navigation/CaseNavigation.vue";
import "v-onboarding/dist/style.css";
import { getSingleCaseOverview } from "@/services/case.service";
import OnboardingCustom from "@/components/OnboardingCustom.vue";


// @ is an alias to /src

export default {
  name: "HomeView",

  components: {

    CaseNavigation,
    OnboardingCustom
  },

  setup() {
    const current_user = useUserStore().user_profile;
    const is_onboarding_visible = ref(false);

    const caseData = ref(null);

    const single_case_uid = router.currentRoute.value.params.uid;

    const steps = [
      
      {
        attachTo: { element: "#ob-case-3" },
        content: {
          title : "Pregled predmeta",
          description:
            "Pritiskom na gumb, možete poslati poruku svim članovima tima. Odgovor možete očekivati u najkraćem mogućem roku.",
        },
      },
    ];

    const dashboardData = ref(null);
    const getAllData = async () => {
      await getSingleCaseOverview(single_case_uid).then((resp) => {
        caseData.value = resp.data;
        gsap
          .from(".general-wrapp", {
            duration: 1,
            x: -100,
            opacity: 0,
            ease: "power1.out",
            force3D: true,
          })
          .then(() => {
            console.log("Animation done", steps);
            is_onboarding_visible.value = true;

          });
      });
    };
    getAllData();
    const returnTimestamp = (dt) => {
      moment().locale("hr");
      return moment(dt).format("DD.MM.YYYY.");
    };
    const returnSpanTimestamp = (start, end) => {
      moment().locale("hr");
      let begin_dt = moment(start).format("DD.MM.YYYY.");
      let end_dt = moment(end).format("DD.MM.YYYY.");
      if (begin_dt == end_dt) {
        return (
          begin_dt +
          moment(start).format(" HH:mm") +
          " - " +
          moment(end).format("HH:mm")
        );
      } else {
        return (
          begin_dt +
          moment(start).format(" HH:mm") +
          " - " +
          end_dt +
          moment(end).format(" HH:mm")
        );
      }
    };
    const isExpired = (dt) => {
      const currentTimestamp = Date.now();
      return currentTimestamp > new Date(dt).getTime();
    };

    const openCase = (case_uid) => {
      router.push("/case/" + case_uid);
    };
    const returnFileType = (file_name) => {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();

      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "dotm":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pptx":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "ppt":
          return_val = require("@/assets/img/ppt-icon.png");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "jpg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "jpeg":
          return_val = require("@/assets/img/jpg_icon.svg");
          break;
        case "png":
          return_val = require("@/assets/img/png_icon.svg");
          break;
        case "folder":
          return_val = require("@/assets/img/folder_yellow.svg");
          break;
        default:
          return_val = require("@/assets/img/dat_icon.svg");
          break;
      }
      return return_val;
    };
    initTooltips();
    const getUserAvatar = (user_uid) => {
      console.log("Tu je", process.env.VUE_APP_GENERAL_API, user_uid);
      return process.env.VUE_APP_GENERAL_API + user_uid + ".jpeg";
    };

    return {
      is_onboarding_visible,
      current_user,
      dashboardData,
      openCase,
      returnTimestamp,
      isExpired,
      returnFileType,
      returnSpanTimestamp,
      getUserAvatar,
      steps,
      caseData,
    };
  },
};
</script>
